import React from 'react'
import '../App.css'

export default function PageContent ({children}) {
  return <div className='app-root-container'>{children}</div>
}
